module.exports = __webpack_public_path__ + "img/bar-chart.f37a6e41.svg";